export const downloadBase64File = ({
  base64Data,
  fileName,
}: {
  base64Data: string
  fileName: string
}) => {
  const linkSource = `data:application/pdf;base64,${base64Data}`
  const downloadLink = document.createElement('a')
  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}
